import { type HttpClient } from '@/application/interfaces/http-client';

import { activateCashback } from './activate-cashback';
import { addProductsToCart } from './add-products-to-cart';
import addServicesToCart from './add-services-to-cart';
import { addServicesToCartById } from './add-services-to-cart-by-id';
import changeItemShipment from './chage-item-shipment';
import changeShipmentModality from './change-shipment-modality';
import { deleteCoupons } from './delete-coupons';
import { getAvailability } from './get-availability';
import { getAvailablePaymentMethods } from './get-available-payment-methods';
import { getCartCashbacks } from './get-cart-cashbacks';
import getCartShipments from './get-cart-shipments';
import getCartSummary from './get-cart-summary';
import { getCashbacksCotationPoints } from './get-cashbacks-cotation-points';
import { getSimilarProducts } from './get-similar-products';
import postCartAddress from './post-cart-address';
import { postCoupons } from './post-coupons';
import { removeProductFromCart } from './remove-product-from-cart';
import { removeServiceFromCart } from './remove-service-from-cart';
import { verifyCreditCardToken } from './verify-credit-card-token';

const cartService = (httpClient: HttpClient.Instance) => ({
  addProductsToCart: addProductsToCart(httpClient),
  addServicesToCart: addServicesToCart(httpClient),
  addServicesToCartById: addServicesToCartById(httpClient),
  changeShipmentModality: changeShipmentModality(httpClient),
  getCartShipments: getCartShipments(httpClient),
  getAvailablePaymentMethods: getAvailablePaymentMethods(httpClient),
  getAvailability: getAvailability(httpClient),
  getCartSummary: getCartSummary(httpClient),
  getCartCashbacks: getCartCashbacks(httpClient),
  postCartAddress: postCartAddress(httpClient),
  removeProductFromCart: removeProductFromCart(httpClient),
  removeServiceFromCart: removeServiceFromCart(httpClient),
  changeItemShipment: changeItemShipment(httpClient),
  getSimilarProducts: getSimilarProducts(httpClient),
  getCashbacksCotationPoints: getCashbacksCotationPoints(httpClient),
  activateCashback: activateCashback(httpClient),
  verifyCreditCardToken: verifyCreditCardToken(httpClient),
  deleteCoupons: deleteCoupons(httpClient),
  postCoupons: postCoupons(httpClient),
});

export default cartService;
